import {type PIXI} from '@colonist/pixi'

export function removePixiObject(pixiObject: PIXI.Container | PIXI.Sprite | PIXI.Graphics | PIXI.Text) {
    pixiObject?.parent?.removeChild(pixiObject)
}

export function bringToFront(container: PIXI.Container) {
    const parent = container.parent
    if(parent === null) return

    parent.removeChild(container)
    parent.addChild(container)
}

export function sendToBack(container: PIXI.Container) {
    const parent = container.parent
    if(parent === null) return

    parent.setChildIndex(container, 0)
}

export function isOverlapping(rect1: PIXI.Rectangle, rect2: PIXI.Rectangle): boolean {
    return rect1.x < rect2.x + rect2.width &&
        rect1.x + rect1.width > rect2.x &&
        rect1.y < rect2.y + rect2.height &&
        rect1.y + rect1.height > rect2.y
}

export function isDescendantOf(child: PIXI.Container, parent: PIXI.Container): boolean {
    if(child.parent == undefined) return false
    if(child.parent == parent) return true
    return isDescendantOf(child.parent, parent)
}
